<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveContinueBtnClick">
      <el-form-item label="站房类别名称" prop="name" :rules="[{
        required: true,
        message: '请输入站房类别名称'
      }]">
        <el-input v-model.trim="model.name" />
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <el-button v-if="operator === 1" type="orange" plain class="btn save-continue-btn" @click="onSaveContinueBtnClick">保存并继续</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'Editor',
  extends: BaseEditor,
  methods: {
    initModel () {
      return {
        id: null,
        name: ''
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/02Site-Category/Editor.vue